import React from 'react';
import { InputMessage } from '../';

const adaptFileEventToValue = delegate => e => delegate(e.target.files[0]);

const FileInput = ({
	className,
	input: { value: omitValue, onChange, onBlur, ...inputProps },
	meta: omitMeta,
	...props
}) => {
	const { submitFailed, error } = omitMeta;

	return (
		<div className={className}>
			<input
				onChange={adaptFileEventToValue(onChange)}
				onBlur={adaptFileEventToValue(onBlur)}
				type="file"
				{...inputProps}
				{...props}
			/>

			{submitFailed && error && <InputMessage>{error}</InputMessage>}
		</div>
	);
};

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/Common/FileInput/FileInput.js